import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=5b6015ea&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=5b6015ea&prod&lang=scss&scoped=true"
import style1 from "./index2.vue?vue&type=style&index=1&id=5b6015ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6015ea",
  null
  
)

export default component.exports